import { z } from "zod";

import { isMoneyText, isNegative, isPositive, money } from "@pharmacy/domain";

/**
 * Money as it travels between the phone and the server: exact decimal text,
 * up to ten decimals — "2.5", "0.005", "0.0000000001". Never a JSON number,
 * which either end would read as a computer decimal and could change in the
 * last places. Read into its shortest form, so "2.50" and "2.5" are the same.
 *
 * The owner's rule (2026-10-02): kept exactly as typed, never rounded.
 */
export const moneyText = z
  .string()
  .max(40)
  .refine(isMoneyText, "Not an amount: digits, with at most 10 after the point")
  .transform((value) => money(value));

/** A price or a cost: zero is fine — free goods are real — below zero is not. */
export const moneyNotNegative = (message = "Cannot be negative") =>
  moneyText.refine((value) => !isNegative(value), message);

/** A payment: something must have been paid. */
export const moneyPositive = (message = "Enter an amount") => moneyText.refine(isPositive, message);
